import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { FPActionButton, FPIconButton, When } from 'UI/components/atoms';
import FPChip from 'UI/components/atoms/FPChip';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

import { DetailsSummary } from '../../shared';
import { buildRelatedEntities } from '../../shared/DetailsSummary/DetailsSummary.utils';

import {
  Header,
  HeaderTitle,
  HeaderTitleContainer,
  LoaderContainer,
  useStyles
} from './SendoutDetailsDrawer.styled';
import { SendoutDetailsTabs } from './SendoutDetailsTabs';

export const SendoutDetailsDrawer = ({ sendoutId, onClose }) => {
  const classes = useStyles();
  const { state } = useFetchWithStatusV2({
    endpoint: sendoutId ? `${Endpoints.Sendouts}/${sendoutId}?` : null,
    apiVersion: 1
  });

  const isFetching = state.status === UIStatus.Loading;

  const sendoutStatus = state.results?.status || {};

  const moreActionsDefinition = [
    {
      title: 'Edit Sendout Details',
      visible: true,
      action: () => console.log('Edit Sendout Details') // TODO: Implement edit sendout details action
    },
    {
      title: 'Closing Call',
      visible: true,
      action: () => console.log('Closing Call') // TODO: Implement closing call action
    }
  ];

  const relatedEntities = buildRelatedEntities(state.results);

  return (
    <FPDrawer
      FPDrawerProps={{ open: true, classes: { paper: classes.drawerLarge } }}
      CardHeaderProps={{ title: sendoutId }}
      onClose={onClose}
      contentContainerClassName={classes.drawerContentContainer}
      header={
        <Header>
          <HeaderTitleContainer>
            <HeaderTitle variant="h5">
              {strings.sendoutsV2.drawers.sendoutDetails.title}
            </HeaderTitle>
            <FPChip
              size="small"
              aria-label="sendout status chip"
              label={sendoutStatus.title}
              variant="outlined"
              color={sendoutStatus.color}
            />
          </HeaderTitleContainer>
          <FPIconButton
            data-testid={strings.shared.ui.close}
            icon={HighlightOffIcon}
            onClick={onClose}
            tooltipProps={{ title: strings.shared.ui.close }}
          />
        </Header>
      }
    >
      <When condition={state.status === UIStatus.Error}>
        <EmptyPlaceholder title={strings.sendoutsV2.drawers.tabs.status.error} />
      </When>
      <When condition={isFetching}>
        <LoaderContainer>
          <CircularProgress />
        </LoaderContainer>
      </When>
      <When condition={state.status === UIStatus.Success}>
        <div className={classes.drawerSection}>
          <DetailsSummary
            title={state.results?.joborder?.title}
            primaryAction={
              <FPActionButton
                text="Start Placement"
                onClick={() => {
                  console.log('Placement');
                }}
              />
            }
            moreActionsDefinition={moreActionsDefinition}
            relatedEntities={relatedEntities}
          />
        </div>
        <SendoutDetailsTabs sendoutId={sendoutId} />
      </When>
    </FPDrawer>
  );
};
